import type { PropsWithChildren } from 'react'

import { useMobileLayoutStore } from '@/stores/MobileLayoutStore'
import { cn } from '@/util/cn'

type SectionHeaderProps = {
  title: string
  subtitle?: string | false
  className?: string
  titleClassName?: string | boolean
} & PropsWithChildren

function SectionHeader({ title, subtitle, className, children, titleClassName }: SectionHeaderProps) {
  const { isMobile, activeMobileTab } = useMobileLayoutStore()

  return (
    <div
      style={{ top: 'calc(var(--header-height) + var(--navbarHeight))' }}
      className={cn(
        'sticky z-10 top-[var(--header-height)] shadow-sm lg:shadow-none grid w-full grid-cols-4 tablet:grid-cols-5 self-baseline rounded-lg bg-rsf-white py-5 items-center',
        isMobile && activeMobileTab === 'deluxe' && 'grid-cols-4',
        className,
      )}
    >
      <div className="col-span-2 flex w-full flex-col gap-0">
        <h3 className={cn(
          'text-nowrap px-2 font-inter text-base sm:text-lg font-bold leading-tight text-rsf-black md:text-wrap md:px-4 md:text-xl md:leading-snug',
          titleClassName,
        )}
        >
          {title}
        </h3>
        {subtitle && (
          <p className="hidden px-4 text-sm leading-tight text-rsf-grey-dark md:block">{subtitle}</p>
        )}
      </div>
      {children}
    </div>
  )
}

export default SectionHeader
